import React from 'react';
import { Sidebar } from '@common/components/sidebar';

export const SupplierSidebar = ({
  selectedItem,
  showReports,
  showTimesheetsItem,
  showBillingItem,
  showOnboardingItem,
  showAdminItem,
}: {
  selectedItem?: string;
  showReports?: boolean;
  showTimesheetsItem?: boolean;
  showBillingItem?: boolean;
  showOnboardingItem?: boolean;
  showAdminItem?: boolean;
}) => (
  <Sidebar logoTo="/works/supplier" selectedItem={selectedItem}>
    {/* TODO[WORK-10177]: rename 'index' for 'requests' */}
    <Sidebar.Item
      key="requests"
      to="/works/supplier/index"
      icon={{ kind: 'light', icon: 'clinicMedical' }}
    >
      Requests
    </Sidebar.Item>
    <Sidebar.Item
      key="candidates"
      to="/works/supplier/candidates"
      icon={{ kind: 'light', icon: 'pollPeople' }}
    >
      Candidates
    </Sidebar.Item>
    <Sidebar.Item
      key="team"
      to="/works/team"
      icon={{ kind: 'light', icon: 'users' }}
    >
      Team
    </Sidebar.Item>
    {showOnboardingItem && (
      <Sidebar.Item
        key="compliance"
        to="/works/supplier/compliance"
        icon={{ kind: 'light', icon: 'clipboardListCheck' }}
      >
        Compliance
      </Sidebar.Item>
    )}
    {showTimesheetsItem ? (
      <Sidebar.Item
        key="timecards"
        to="/works/supplier/timecards"
        icon={{ kind: 'light', icon: 'clock' }}
      >
        Timecards
      </Sidebar.Item>
    ) : null}
    {showBillingItem && (
      <Sidebar.Item
        key="billing"
        to="/works/supplier/billing"
        icon={{ kind: 'light', icon: 'fileInvoice' }}
      >
        Billing
      </Sidebar.Item>
    )}
    {showReports && (
      <Sidebar.Item
        key="reports"
        to="/works/reports"
        icon={{ kind: 'light', icon: 'chartBar' }}
      >
        Reports
      </Sidebar.Item>
    )}
    {showAdminItem && (
      <Sidebar.Item
        key="admin"
        to="/works/supplier/admin"
        icon={{ kind: 'light', icon: 'userCog' }}
      >
        Admin
      </Sidebar.Item>
    )}
  </Sidebar>
);
